"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactTransitionGroup = require("react-transition-group");

var _moment = _interopRequireDefault(require("moment"));

var _ToolPanel = _interopRequireDefault(require("./MenuPanels/ToolPanel"));

var _SearchPanel = _interopRequireDefault(require("./MenuPanels/SearchPanel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import HelpPanel from './MenuPanels/HelpPanel';


var MenuPanel = function MenuPanel() {
  var currentMenu = (0, _reactRedux.useSelector)(function (state) {
    return state.menuReducer.currentMenu;
  });
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    appear: currentMenu !== undefined,
    in: currentMenu !== undefined,
    timeout: 300,
    classNames: 'menu-panel'
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'MenuPanel'
  }, /*#__PURE__*/_react.default.createElement(_ToolPanel.default, null), /*#__PURE__*/_react.default.createElement(_SearchPanel.default, null), /*#__PURE__*/_react.default.createElement("div", {
    id: 'copyright'
  }, "Storm Center 4.8", /*#__PURE__*/_react.default.createElement("br", null), "Copyright ", (0, _moment.default)().year(), " KUBRA")));
};

var _default = MenuPanel;
exports.default = _default;